import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'inside-out/components/shared/link';
import ArrowIconLarge from 'inside-out/components/shared/icons/arrowIconLarge';
import LinkIcon from 'inside-out/components/shared/icons/linkIcon';
import { buttonStyle, buttonTextStyle, arrowIconStyle, iconStyle } from './styles';

const renderIcon = (icon) => {
	let svgIcon;
	switch(icon) {
		case 'link':
			svgIcon = <LinkIcon/>;
			break;
		default:
			return null;
	}
	return <span className={iconStyle}>{svgIcon}</span>;
}

export const FullWidthCTA = props => {
	const { icon, link, color, onClick } = props;
	if (!(link && link.href) && !(link && link.to) && !onClick) {
		throw new Error(
			"You must supply either href, to, or onClick. Use to if it's a link to another page, use href if it's an external resource."
		);
	}
	if (onClick) {
		return (
			<a
				className={buttonStyle(color)}
				data-component="FullWidthCTA"
				onClick={e => {
					e.preventDefault();
					onClick(e);
				}}
			>
				{renderIcon(icon)}
				<span className={buttonTextStyle}>{props.children}</span>
				<span className={arrowIconStyle}>
					<ArrowIconLarge fill="#fff" width={24} height={24} />
				</span>
			</a>
		);
	} else if (link.to) {
		// TODO: This is gross. Find a way to swap out Link -> <a> without copying and pasting here.
		return (
			<Link className={buttonStyle(color)} to={link.to} data-component="FullWidthCTA">
				{renderIcon(icon)}
				<span className={buttonTextStyle}>{props.children}</span>
				<span className={arrowIconStyle}>
					<ArrowIconLarge fill="#fff" width={24} height={24} />
				</span>
			</Link>
		);
	} else if (link.href) {
		return (
			<a
				className={buttonStyle(color)}
				href={link.href}
				target="_blank"
				rel="noopener noreferrer"
				data-component="FullWidthCTA"
			>
				{renderIcon(icon)}
				<span className={buttonTextStyle}>{props.children}</span>
				<span className={arrowIconStyle}>
					<ArrowIconLarge fill="#fff" width={24} height={24} />
				</span>
			</a>
		);
	}
};

FullWidthCTA.propTypes = {
	icon: PropTypes.string,
	color: PropTypes.string,
	link: PropTypes.shape({
		to: PropTypes.string,
		href: PropTypes.string,
	}),
	onClick: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/shared/fullWidthCTA/component.js